var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _vm.isBillingBalanceBelowCritical
            ? _c("p", { staticClass: "warning_text" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("transferIsBillingBalanceBelowCritical")) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasProductEmptyUpc
            ? _c("p", { staticClass: "warning_text" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("productsMustHaveUpc")) + "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.submitError
            ? _c("p", { staticClass: "warning_text" }, [
                _vm._v("\n      " + _vm._s(_vm.submitError) + "\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                disabled: _vm.isBillingBalanceBelowCritical
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.showAddInventoriesDialog()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("addItem")))]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-2 myDense",
        attrs: {
          headers: _vm.headers,
          items: Object.values(_vm.value),
          "item-key": "shipmentProductKey",
          "hide-actions": ""
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c(
                  "td",
                  [
                    _c("ProductWidget", {
                      attrs: {
                        name: props.item.name,
                        condition: props.item.condition,
                        upc: props.item.upc
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.userName))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.siteName))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c("v-text-field", {
                          attrs: { autofocus: "", mask: "#####" },
                          on: {
                            change: function($event) {
                              return _vm.quantityChanged($event, props.item)
                            }
                          },
                          model: {
                            value: props.item.toShip,
                            callback: function($$v) {
                              _vm.$set(props.item, "toShip", _vm._n($$v))
                            },
                            expression: "props.item.toShip"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c("v-text-field", {
                          model: {
                            value: props.item.unitPrice,
                            callback: function($$v) {
                              _vm.$set(props.item, "unitPrice", _vm._n($$v))
                            },
                            expression: "props.item.unitPrice"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.quantity))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-right" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { dark: "", color: "primary", flat: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.deleteProduct(props.item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("remove")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.addInventoriesDialog
        ? _c("AddInventories", {
            attrs: {
              title: _vm.$t("selectProduct"),
              addedDistributionSet: _vm.addedDistributionSet,
              editMode: true,
              hasOnlyWarehouse: "",
              allDistribution: _vm.allDistribution
            },
            on: {
              deleteDistribution: function(item) {
                return _vm.deleteProduct(item)
              },
              addDistribution: function(item) {
                return _vm.addProduct(item)
              }
            },
            model: {
              value: _vm.addInventoriesDialog,
              callback: function($$v) {
                _vm.addInventoriesDialog = $$v
              },
              expression: "addInventoriesDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62a8f358", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62a8f358","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductTableAndSelect.vue
// module id = null
// module chunks = 